import { Injectable, Injector } from '@angular/core';
import { PerfilAssinatura } from '../../entidade/comum/perfil-assinatura.model';
import { BaseResourceService } from '../../models/services/base-resource.service';

@Injectable({
  providedIn: 'root'
})
export class PerfilAssinaturaService extends BaseResourceService<PerfilAssinatura> {

  constructor(
    protected injector: Injector
  ) {
    super(`perfis-assinaturas`, injector);
  }

}
